module.exports = __webpack_public_path__ + "assets/img/xb.cbe5ef0a.png";